import React from "react";
import AllReports from "../../components/Reports.js/AllReports";

function ReportAccounts() {
  return (
    <div>
      <AllReports />
    </div>
  );
}

export default ReportAccounts;
